
















import Vue from "vue";

interface Props {
  expandable?: boolean;
}

export default Vue.extend<Props>({
  name: "BaseInputSubmit",
  functional: true,
  props: {
    expandable: { type: Boolean, required: false, default: undefined }
  }
});
